module.exports = __webpack_public_path__ + "media/background.48bcd316.mp4";